import React from "react";
import { Field } from "redux-form";
import { Select } from "../../library";
import buildFormField from "./buildFormField";
import memoize from "fast-memoize";
import { useCallback } from "react";

const FormField = buildFormField(Select, (input, meta, rest) => ({
  ...input,
  invalid: (meta.touched && meta.invalid).toString(),
  onChange: useCallback((_, data) => input.onChange(data.value)),
  onBlur: undefined,
  ...rest,
}));

const buildValidator = memoize((required, other) => {
  return [(value) => (required && !value ? "required" : undefined)].concat(
    other || []
  );
});

export default function DropdownField(props) {
  return (
    <Field
      {...props}
      component={FormField}
      validate={buildValidator(props.required, props.validate)}
    />
  );
}
